<script lang="ts">
  import Modal from "./Modal.svelte";
  import Popper from "./Popper.svelte";

  export let overlay: "inline" | "modal";
  export let open: boolean;
  export let input: HTMLElement;
  export let closeLabel: string;
</script>

{#if overlay === "inline"}
  <Popper {closeLabel} {input} bind:open on:close let:methods>
    <slot overlay={methods} />
  </Popper>
{:else}
  <Modal {closeLabel} bind:open on:close>
    <slot overlay={{ resize() {} }} />
  </Modal>
{/if}
